import { Component, OnInit } from "@angular/core";
import { Globals } from "../globals";

@Component({
  selector: "app-vista-admin-usuario",
  templateUrl: "./vista-admin-usuario.component.html",
  styleUrls: ["./vista-admin-usuario.component.css"]
})
export class VistaAdminUsuarioComponent implements OnInit {
  constructor(public globals: Globals) {}
  
  buscarUsuario($event) {
    //////conole.log($event);
    this.globals.contenedorVarGlobal = $event;
  }
  
  ngOnInit() {}

  buscarusuario() {
    this.globals.contenedorVarGlobal = "buscar";
  }

  crearNuevoUsuario() {
    this.globals.contenedorVarGlobal = "formulario";
    this.globals.tipoFormularioVarGlobal = "Crear";
  }

  cargaMasiva() {
    this.globals.contenedorVarGlobal = "carga";
  }

  encuesta() {
    this.globals.contenedorVarGlobal = "encuesta";
  }

  enviados(){
    this.globals.contenedorVarGlobal = "enviados";
  }
}
